<template>
  <div id="index">

    <div class="common-level-rail">
      <el-button type="primary" size="small" icon="el-icon-plus" v-auth="'/protocol/protocol/add'" @click="$refs.addEditRef.show()">添加</el-button>
    </div>

<!--
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchObj" >
        <el-form-item label="关键词">
          <el-input size="small" v-model="searchObj.search" placeholder="请输入姓名/店铺名/电话"></el-input>
        </el-form-item>

        <el-form-item label="申请状态">
          <el-select size="small" v-model="searchObj.status" placeholder="请选择申请状态">
            <el-option v-for="(item, index) in statusList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请类型">
          <el-select size="small" v-model="searchObj.type" placeholder="请选择申请类型">
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="日期">
          <el-date-picker size="small" v-model="time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="dateChange"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="pageChange(1)">查询</el-button>
        </el-form-item>

      </el-form>
    </div> -->


    <div class="product-content">
      <el-table size="small" :data="list" border style="width: 100%">
        <el-table-column prop="title" label="名称"></el-table-column>
        <el-table-column prop="create_time" label="日期"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-auth="'/protocol/protocol/edit'" @click="$refs.addEditRef.show(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination @current-change="pageChange" background  :current-page="searchObj.page" :page-size="searchObj.list_rows" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>

    </div>

    <!-- 详情 -->
    <addEdit ref="addEditRef" @refresh="getData"></addEdit>

  </div>
  </template>

  <script>
  import SettingApi from '@/api/setting.js';
  import addEdit from './addEdit.vue';
  export default {
    components:{addEdit,},
    data(){
      return{
        searchObj:{
          page:1,
          list_rows:10,
        },
        list:[],
        total:0,
      }
    },
    created(){
      this.getData()
    },
    methods:{
      // 获取列表数据
      getData(){
        SettingApi.protocolIndex(this.searchObj, true).then(res => {
          this.list=res.data.list.data
          this.total=res.data.list.total
        })
      },

      // 分页
      pageChange(e){
        this.searchObj.page=e
        this.getData()
      },


    }
  }
  </script>

  <style>

  </style>



// WEBPACK FOOTER //
// src/views/setting/protocol/index.vue